import { formatCurrency } from "@compass/core";
import { getPdfReportSpacing, PdfReportCss, PdfReportDataDisplay, PdfReportHeader, PdfReportSignBox } from "components";
import { MatchReportPartner, MatchReportPartnerRow } from "generated/openApi";

export const PartnerHtml = (props: { report: MatchReportPartner }) => {
  const renderFilters = (partnerRow: MatchReportPartnerRow) => {
    const dataDisplayLabelWidth = "140px";

    return (
      <div style={{ paddingBottom: getPdfReportSpacing("md") }}>
        <PdfReportDataDisplay
          label="Partner"
          value={partnerRow.partner?.name}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Sub-Partner"
          value={partnerRow.subPartner?.name}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Partner Address"
          value={partnerRow.partner?.formattedAddress}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Contact's Name"
          value={
            partnerRow.partner?.contactContributor
              ? `${partnerRow.partner?.contactContributor?.lastName}, ${partnerRow.partner?.contactContributor?.firstName}`
              : ""
          }
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Contact's Title"
          value={partnerRow.partner?.contactContributorTitle}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Report Period"
          value={
            <>
              {props.report.dateFrom && new Date(props.report.dateFrom).toLocaleDateString()} to{" "}
              {props.report.dateTo && new Date(props.report.dateTo).toLocaleDateString()}
            </>
          }
          labelStyle={{ width: dataDisplayLabelWidth }}
        />

        <PdfReportDataDisplay
          label="Status"
          value={props.report.reviewName}
          labelStyle={{ width: dataDisplayLabelWidth }}
        />
      </div>
    );
  };

  const renderConfirmText = () => {
    return (
      <div style={{ paddingBottom: getPdfReportSpacing("md") }}>
        The following costs were donated on behalf of the GEAR UP grant:
      </div>
    );
  };

  const renderAmounts = (partnerRow: MatchReportPartnerRow) => {
    const valueStyle: React.CSSProperties = { textAlign: "right" };
    const dataDisplayLabelWidth = "300px";

    return (
      <div style={{ paddingBottom: getPdfReportSpacing("md") }}>
        <PdfReportDataDisplay
          label="Salary and Wages"
          value={formatCurrency(partnerRow.amountSum)}
          labelStyle={{ width: dataDisplayLabelWidth }}
          valueStyle={{ ...valueStyle }}
        />

        <PdfReportDataDisplay
          label="Employee Benefits"
          value={formatCurrency(partnerRow.benefitSum)}
          labelStyle={{ width: dataDisplayLabelWidth }}
          valueStyle={{ ...valueStyle }}
        />
        <PdfReportDataDisplay
          label="Travel"
          value={formatCurrency(partnerRow.travelSum)}
          labelStyle={{ width: dataDisplayLabelWidth }}
          valueStyle={{ ...valueStyle }}
        />
        <PdfReportDataDisplay
          label="Equipment"
          value={formatCurrency(partnerRow.equipmentSum)}
          labelStyle={{ width: dataDisplayLabelWidth }}
          valueStyle={{ ...valueStyle }}
        />
        <PdfReportDataDisplay
          label="Materials and Supplies"
          value={formatCurrency(partnerRow.suppliesSum)}
          labelStyle={{ width: dataDisplayLabelWidth }}
          valueStyle={{ ...valueStyle }}
        />
        <PdfReportDataDisplay
          label="Consultants and Contracts"
          value={formatCurrency(partnerRow.consultantSum)}
          labelStyle={{ width: dataDisplayLabelWidth }}
          valueStyle={{ ...valueStyle }}
        />
        <PdfReportDataDisplay
          label="Other"
          value={formatCurrency(partnerRow.otherSum)}
          labelStyle={{ width: dataDisplayLabelWidth }}
          valueStyle={{ ...valueStyle }}
        />

        <div style={{ paddingBottom: getPdfReportSpacing("md") }}></div>

        <PdfReportDataDisplay
          label="Total Direct Costs"
          value={formatCurrency(partnerRow.totalDirectCost)}
          labelStyle={{ width: dataDisplayLabelWidth }}
          valueStyle={{ ...valueStyle }}
        />

        <PdfReportDataDisplay
          label="Total Indirect Costs"
          value={formatCurrency(partnerRow.totalIndirectCost)}
          labelStyle={{ width: dataDisplayLabelWidth }}
          valueStyle={{ ...valueStyle }}
        />

        <PdfReportDataDisplay
          label="Scholarships/Tuition Assistance"
          value={formatCurrency(partnerRow.scholarshipSum)}
          labelStyle={{ width: dataDisplayLabelWidth }}
          valueStyle={{ ...valueStyle }}
        />

        <div style={{ paddingBottom: getPdfReportSpacing("md") }}></div>

        <PdfReportDataDisplay
          label="Total"
          value={formatCurrency(partnerRow.total)}
          labelStyle={{ width: dataDisplayLabelWidth }}
          valueStyle={{ ...valueStyle }}
        />
      </div>
    );
  };

  const renderSignArea = () => {
    return (
      <div>
        <PdfReportSignBox label="Signature" />
        <PdfReportSignBox label="Date" />
      </div>
    );
  };

  return (
    <>
      <PdfReportCss />
      <div>
        {props.report.partnerRows?.map((partnerRow) => (
          <div style={{ pageBreakAfter: "always" }}>
            <PdfReportHeader title={"Match Partner Report"} tenantName={props.report.tenantName} />

            {renderFilters(partnerRow)}

            {renderConfirmText()}

            {renderAmounts(partnerRow)}

            {renderSignArea()}
          </div>
        ))}
      </div>
    </>
  );
};
